// Guest response claiming: a guest who RSVP'd via a shared round link gets
// a ?claim={guest_token} param on the signup CTA. The token is stashed in
// localStorage (it must survive the email-confirmation redirect, which
// drops query params) and redeemed once a session exists - AuthContext
// calls attemptClaim() on every auth-state change; the RPC is idempotent
// and the token is cleared after a successful claim.

import { supabase } from '../lib/supabase'
import { trackEvent } from '../services/analytics'

const CLAIM_KEY = 'teesync_guest_claim_token'
const UUID_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i

export function stashClaimTokenFromUrl() {
  try {
    const token = new URLSearchParams(window.location.search).get('claim')
    if (token && UUID_RE.test(token)) {
      localStorage.setItem(CLAIM_KEY, token)
    }
  } catch {
    // localStorage unavailable - claim just won't survive the redirect
  }
}

export async function attemptClaim(user) {
  let token
  try {
    token = localStorage.getItem(CLAIM_KEY)
  } catch {
    return
  }
  if (!token || !user) return

  try {
    const { data: claimed, error } = await supabase.rpc('claim_guest_responses', {
      p_guest_token: token,
    })
    if (error) {
      console.error('Error claiming guest responses:', error)
      return
    }
    localStorage.removeItem(CLAIM_KEY)
    if (claimed > 0) {
      trackEvent('guest_account_claimed', { claimed_count: claimed })
    }
  } catch (error) {
    console.error('Exception claiming guest responses:', error)
  }
}
